var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcUserBan = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M11.5 11a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m0-2a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.803 15.583C5.71 16.578 5 18.053 5 20a1 1 0 1 1-2 0c0-2.471.919-4.496 2.457-5.896C6.984 12.714 9.054 12 11.273 12a9.4 9.4 0 0 1 3.05.49 1 1 0 0 1-.646 1.893A7.4 7.4 0 0 0 11.273 14c-1.798 0-3.364.577-4.47 1.583"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M18 20.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m0-1.5c.294 0 .572-.063.823-.177l-2.646-2.646A2 2 0 0 0 18 19m-.738-3.86 2.597 2.598a2 2 0 0 0-2.597-2.597",
  clipRule: "evenodd"
})));
export default SvgIcUserBan;